module.exports = __webpack_public_path__ + "static/img/xxpp-details.ddf85fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xxpp-details.png
// module id = vpc7
// module chunks = 0